import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import Divider from './Divider';
import './Testimonial.css';

export default class Testimonial extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            testimonials: [],
        };
    }

    componentDidMount() {
        fetch('./config/testimonial.json')
            .then((response) => {
                return response.json();
            })
            .then((testimonial) => {
                this.setState(
                    {
                        testimonials: testimonial,
                    },
                    () => {
                        this.carousel.play();
                        this.props.callback(true);
                    },
                );
            });
    }

    render() {
        return (
            <div>
                <div
                    className="big-title text-center animated fadeInDown delay-01"
                    data-animation="fadeInDown"
                    data-animation-delay="01"
                >
                    <h1 className="iwh-title">
                        Dernières{' '}
                        <span className="accent-color">nouvelles</span>
                    </h1>
                </div>
                <Divider type={5} />
                {this.state.testimonials.length === 0 ? null : (
                    <OwlCarousel
                        ref={(el) => (this.carousel = el)}
                        className="owl-theme"
                        loop
                        margin={10}
                        items={1}
                        autoplay={true}
                        autoplayTimeout={3000}
                    >
                        {this.renderTestimonial()}
                    </OwlCarousel>
                )}
            </div>
        );
    }

    renderTestimonial() {
        return this.state.testimonials.map((tm, index) => (
            <div className="item container text-center" key={index}>
                <div className="icon accent-color">
                    <i className="fa fa-quote-left"></i>
                </div>
                <div className="testi-client-name">{tm.name}</div>
                <div className="testi-desc">
                    {this.renderTestimonialDescription(tm.description)}
                </div>
            </div>
        ));
    }

    renderTestimonialDescription(descriptions) {
        return descriptions.map((description, index) => (
            <div key={index}>
                {description}
                <br />
            </div>
        ));
    }
}

Testimonial.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/Testimonial.jsx